import PropTypes from 'prop-types';
import CustomButton from '../../atomic/atoms/custom-button.atom.jsx';
import CustomText from '../../atomic/atoms/custom-text.atom.jsx';
import Content from '../atoms/content.atom.jsx';

const CurpConfirmationTemplate = ({ curp, onConfirm, onEdit }) => {
    return (
        <div style={styles.container}>
            <div style={{flexGrow: 1}}/>
            <Content>
            <CustomText variant={'headline4xl'} style={{textAlign: 'center'}}>
                    ¿Estás seguro que éste es tu CURP?
                </CustomText>
                <CustomText variant="headlineXl" style={{textAlign: 'center'}}>
                    {curp.toUpperCase()}
                </CustomText>
                <CustomButton
                    variant="yellow"
                    onClick={onEdit}
                >
                    Editar CURP
                </CustomButton>
                <CustomButton
                    variant={'white'}
                    onClick={onConfirm}>
                    Si, ese es mi CURP
                </CustomButton>
            </Content>
            <div style={{flexGrow: 1}}/>
        </div>
    );
};

CurpConfirmationTemplate.propTypes = {
    curp: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
};

const styles = {
    container: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: 'inherit',
        height: 'inherit',
        padding: '20px',
        boxSizing: 'border-box',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '20px',
        textAlign: 'center',
    },
};

export default CurpConfirmationTemplate;